module.exports = __webpack_public_path__ + "static/media/fa-solid-900.e7578a9d.svg";